import { getGlobalCssUrl, getComponentCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createPropertyListTemplate() {
    const t = document.createElement('template');
    t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('PropertyList--wc.css')}" rel="stylesheet" />
`;
    return t;
}

// Getter function for template
const getTemplatePropertyListStyles = () => createPropertyListTemplate();
export { getTemplatePropertyListStyles as TemplatePropertyListStyles }
